// React
import { ReactNode } from "react"

// UI
import { PageTemplate } from "@/layouts/PageTemplate"
import { ProfileSubMenuTabs } from "@/pages/profile/components/ProfileSubMenuTabs"

// Error handling
import { ErrorBoundary } from "@/components/errors/ErrorBoundary"
import { ErrorState } from "@/components/errors/ErrorState"

// Translations
import { useTrans } from "@/i18n"

// Pages
import { AppSettings } from "@/pages/profile/pages/AppSettings"
import { BankDetails } from "@/components/forms/BankDetails"
import { PersonalDetails } from "./components/PersonalDetails"
import { ContactDetailsForm } from "./components/ContactDetailsForm"

/**
 * ProfileLayout
 * @param param0
 * @returns
 */
export function ProfileLayout({ children }: { children: ReactNode }) {
	const t = useTrans("profile")

	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("profile:profile.my_profile.title"),
				})}
			</title>
			<PageTemplate
				title={t("profile:profile.header")}
				tabs={<ProfileSubMenuTabs />}
			>
				{children}
			</PageTemplate>
		</>
	)
}

export const ProfilePersonalData = () => {
	const t = useTrans("profile")

	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("profile:profile.personal_details.title"),
				})}
			</title>
			<div>
				<ErrorBoundary fallback={<ErrorState />}>
					<div className="flex flex-col gap-4">
						<PersonalDetails />
						<ContactDetailsForm />
					</div>
				</ErrorBoundary>
			</div>
		</>
	)
}

export const SettingsApp = () => {
	const t = useTrans("profile")

	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("profile:profile.settings.app"),
				})}
			</title>
			<div>
				<ErrorBoundary fallback={<ErrorState />}>
					<AppSettings />
				</ErrorBoundary>
			</div>
		</>
	)
}

export const ProfileBankDetails = () => {
	const t = useTrans("profile")

	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("profile:profile.bank_details.title"),
				})}
			</title>
			<div>
				<ErrorBoundary fallback={<ErrorState />}>
					<BankDetails />
				</ErrorBoundary>
			</div>
		</>
	)
}

export const ProfileSecurityComponentLayout = ({
	children,
}: {
	children: ReactNode
}) => {
	const t = useTrans("profile")

	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("profile:profile.security.title"),
				})}
			</title>
			<ErrorBoundary fallback={<ErrorState />}>{children}</ErrorBoundary>
		</>
	)
}
